module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/3JV0xB/tc-custom/9781460346273.jpg?1700849398980",
      "alt": "This image is the cover for the book Prince's Pleasure"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Prince's Pleasure\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Reporter Tyler Wood can't believe her luck when she gets to shadow Zak Prince for a week. An exclusive interview with the handsome Hollywood actor could make her career! Zak Prince can't believe his luck when he meets Tyler! He hadn't wanted to be followed around by some nosy reporter, but working with this stunning brunette won't be a hardship at all! Soon, however, candid photos are appearing in the press. Zak feels furious and betrayed. Could Tyler set him up?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Carole Mortimer\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Carole Mortimer was born in England, the youngest of three children. She began writing in 1978, and has now written over one hundred and seventy books for Harlequin Mills and Boon®. Carole has six sons, Matthew, Joshua, Timothy, Michael, David and Peter. She says, ‘I’m happily married to Peter senior; we’re best friends as well as lovers, which is probably the best recipe for a successful relationship. We live in a lovely part of England.’")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0